import { useState } from 'react';
import { withNamespaces } from 'react-i18next';
import {
    Card,
    CardBody,
    Col,
    Row,
} from 'reactstrap';

import ReportDetail from './ReportDetail';
import ReportsList from './ReportsList';

const CompanyData = ({
    carrier,
    t,
}) => {
    const reports = carrier.companyReports || [];
    const [selectedReportId, setSelectedReportId] = useState(reports[0]?.id);
    const selectedReport = reports.find((report) => report.id === selectedReportId) || reports[0];

    if (!selectedReport) {
        return (
            <Card>
                <CardBody>
                    <div className="alert m-0" role="alert">
                        <p className="text-center mb-0">{t('This section is empty')}</p>
                    </div>
                </CardBody>
            </Card>
        );
    }

    return (
        <Row>
            <Col lg="3">
                <Card>
                    <CardBody>
                        <ReportsList
                            onSelect={setSelectedReportId}
                            reports={reports}
                            selectedReportId={selectedReport.id}
                        />
                    </CardBody>
                </Card>
            </Col>

            <Col lg="9">
                <Card>
                    <CardBody>
                        <ReportDetail report={selectedReport} />
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

export default withNamespaces()(CompanyData);
